/**
 *  Components Library file
 *  @memberOf components.Popover
 *  @link https://react-spectrum.adobe.com/react-aria/Popover.html
 */

import type {
  DialogProps as AriaDialogProps,
  PopoverProps as AriaPopoverProps,
} from "react-aria-components";
import {
  Button,
  Dialog as AriaDialog,
  DialogTrigger as AriaPopoverProvider,
  Popover as AriaPopover,
} from "react-aria-components";

export interface PopoverTriggerProps
  extends Omit<Partial<AriaPopoverProps>, "trigger"> {
  children: React.ReactNode;
  className?: string;
}

export const PopoverTrigger = ({
  children,
  className,
}: PopoverTriggerProps) => {
  return <Button className={className}>{children}</Button>;
};

export interface PopoverContentProps
  extends Omit<Partial<AriaPopoverProps>, "trigger"> {
  children: React.ReactNode;
  dialogProps?: Partial<AriaDialogProps>;
  className?: string;
}

export function PopoverContent({
  children,
  dialogProps,
  className,
  ...props
}: PopoverContentProps) {
  return (
    <AriaPopover {...props} className={className}>
      <AriaDialog {...dialogProps}>{children}</AriaDialog>
    </AriaPopover>
  );
}

export interface PopoverProviderProps
  extends Omit<Partial<AriaPopoverProps>, "trigger"> {
  children: React.ReactNode;
}

export function PopoverProvider({ children, ...props }: PopoverProviderProps) {
  return <AriaPopoverProvider {...props}>{children}</AriaPopoverProvider>;
}
